<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-floor`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.564 4h34.872c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54v34.873c0 .892-.093 1.215-.267 1.54-.174.327-.43.583-.756.757-.326.174-.65.267-1.54.267H6.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 01-.757-.756c-.174-.326-.267-.65-.267-1.54V6.563c0-.892.093-1.215.267-1.54.174-.327.43-.583.756-.757.326-.174.65-.267 1.54-.267zm16.992.615l2.829 2.829-4.057 4.056L28 17.171 39.385 5.787l2.828 2.828L19.578 31.25l5.922 5.922L41.132 21.54l2.828 2.828L28.328 40l.39.39-2.829 2.828-.39-.389-.63.632-2.83-2.828.633-.632-5.922-5.922-8.478 8.478-2.828-2.828 19.728-19.729-5.672-5.67L7.293 26.534l-2.829-2.828L23.556 4.615zM8 8v32h32V8H8z"/></svg>
</template>
<script>

export default {
  name: 'IconFloor',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
